import { BabyCarriageOffIcon } from './BabyCarriageOffIcon';

/**
 * author: Michael Richins
 * id D495FD84-4476-4E2E-B099-4E0A07AA9D90
 * name baby-carriage-off
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/baby-carriage-off.svg
 * tags
 * - People / Family 
 */
export const PramOffIcon = BabyCarriageOffIcon;
export default PramOffIcon